import { Component, ElementRef, OnInit, ViewChild, ViewEncapsulation } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { DatatableComponent, ColumnMode } from '@swimlane/ngx-datatable';
import { ApiService } from 'app/shared/services/api.service';
import { SessionStorageService } from 'app/shared/services/session-storage.service';
import { environment } from 'environments/environment';
import moment from 'moment';
import { NgxSpinnerService } from 'ngx-spinner';
import { ToastrService } from 'ngx-toastr';
import { AddAttendanceComponent } from './add-attendance/add-attendance.component';

@Component({
  selector: 'app-myclass',
  templateUrl: './myclass.component.html',
  styleUrls: ['./myclass.component.scss'],
  encapsulation: ViewEncapsulation.None

})
export class MyclassComponent implements OnInit {
 
  @ViewChild(DatatableComponent) table: DatatableComponent;
  @ViewChild('name') inputName;
  classForm:FormGroup
  page = {
    pageNumber: 0,
    offset: 0,
    pageSize: 100,
    totalPages: 0
  };
  // row data
  public rows = [];
  public filterRows = [];
  public ColumnMode = ColumnMode;
  public limitRef = 100;
  selectedValue = ''
  isFilter: boolean = false
  // column header
  public columns = [
    { name: " Topic Name", prop: "topic" },
    { name: "Date", prop: "date" },
    { name: "Time", prop: "time" },
    { name: "Actions", prop: "actions" },
  ];

  // private
  private tempData = [];
  imageUrl = environment.apiUrls.imageUrl;
  user_role: any
  main_menu_id:any
  activeTab:any
  class_id:any
  att_List=[
    { name:'Yes',id:'yes'},
    { name:'No',id:'no'},
  ]
  selected_att:any
  stu_feedback:string = "";
  feedback = new FormControl();
  privateFeedback = new FormControl();
  topic_list=[]
  select_topic=null
  studentData:any
  current_id:any
    constructor(public apiService: ApiService, private spinner: NgxSpinnerService,
      public toastr: ToastrService, private modalService: NgbModal,
      private activeRouter: ActivatedRoute) {
    this.user_role = JSON.parse(localStorage.getItem('user'))
    this.activeRouter.paramMap.subscribe(params => { 
      this.current_id = params.get('id'); 
    });
  }

  ngOnInit() {
    this.getStudentAttendanceById(this.current_id)
    this.getStudentById()
  }
  getClass(id){
    this.spinner.show(undefined,
      {
        type: 'ball-triangle-path',
        size: 'medium',
        bdColor: 'rgba(0, 0, 0, 0.8)',
        color: '#fff',
        fullScreen: true
      });
    this.apiService.getClassByUserId(id).subscribe((res:any)=>{
      this.spinner.hide()
      this.rows = res?.data
      this.page.totalPages = res?.data?.length
    })
  }
  getStudentAttendanceById(id){
    this.spinner.show(undefined,
      {
        type: 'ball-triangle-path',
        size: 'medium',
        bdColor: 'rgba(0, 0, 0, 0.8)',
        color: '#fff',
        fullScreen: true
      });
    this.apiService.getStudentAttendenceByUserId(id).subscribe((res:any)=>{
      this.spinner.hide()
      this.rows = res?.data
      this.page.totalPages = res?.data?.length
    })
  }
  openModal(id) {
    this.class_id = id
    const modalRef = this.modalService.open(AddAttendanceComponent)
    modalRef.result.then((result) => {
      this.addStudentAttendence(this.class_id,result)
    }, (reason) => {
      console.log(`Modal dismissed with reason: ${reason}`);
    });
   
  }
 
  pageChangeData(page: any) {
    // this.spinner.show(undefined,
    //   {
    //     type: 'ball-triangle-path',
    //     size: 'medium',
    //     bdColor: 'rgba(0, 0, 0, 0.8)',
    //     color: '#fff',
    //     fullScreen: true
    //   });
    // this.apiService.getAllJobs(page.offset + 1, page.pageSize).subscribe((res: any) => {
    //   this.spinner.hide()
    //   this.rows = res.data.items
    //   this.page.totalPages = res.data.totalCount
    // })
  }
  getAttId(event){
    this.selected_att = event.id
  }
  submit(){
      let body={
        classId: this.class_id,
        userId: this.user_role?.id,
        stu_attendance: this.selected_att,
        stu_feedback: this.feedback.value,
        private_feedback : this.privateFeedback.value,
        topicId : this.select_topic
      }
      this.apiService.addAttendance(body).subscribe((res:any)=>{
        if(res?.statusCode === 200){
          this.toastr.success(res.message)
          let body = {
            topicId : this.select_topic
          }
          this.modalService.dismissAll()
          this.getClass(this.user_role?.id)

        }
        else{
          this.toastr.error(res.error)
        }
      })
  }
  getTopicId(event){
    this.select_topic    
  }
  getTopicList(id){
    this.apiService.getTopicsByCourseId(id).subscribe((res:any)=>{
      if(res.statusCode === 200){
        const extractedData = res?.data.map((item) => {
          return item.data.flatMap((subArray) => {
            return subArray.flatMap((innerArray) => {
              return innerArray.map((obj) => {
                return {
                  name: obj.name,
                  _id: obj._id
                };
              });
            });
          });
        });
        this.topic_list = extractedData.flat()
      }
    })
  }
  getStudentById(){
    this.apiService.getStudentById(this.user_role.id).subscribe((res:any)=>{
      this.studentData =res.data;
      if(res.data?.course?._id){
        this.getTopicList(res.data?.course?._id)
      }
    })
  }


  isAbsent(time): boolean {
  const currentDate = new Date();
  const currentHour = currentDate.getHours();
  const currentMinute = currentDate.getMinutes();
  const currentTime = currentHour + ':' + currentMinute
  return currentTime < time;
}

  addStudentAttendence(class_id,feedbackForm) {
    console.log(feedbackForm)
    this.apiService.addAttendence(class_id,this.current_id,feedbackForm).subscribe((res: any) => {
      if (res?.isSuccess) {
        this.toastr.success('Attendence marked successfully');
        this.getStudentAttendanceById(this.current_id)
      }
      else{
        this.toastr.error(res?.error)
        this.getStudentAttendanceById(this.current_id)
      }
    })
  }
}